export default "__VITE_ASSET__C2XodyM3__"